import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { compareStrings } from '@cbridge-utils/object';
import { ICoverageServer } from '../coverageServer.interface';
import { coverageServerStoreSelector } from '../coverageServer.selector';

export const coverageServerListSelector = createCachedSelector(
  [
    path(coverageServerStoreSelector).data(),
    path(coverageServerStoreSelector).listNetworkStatus(),
  ],
  (data, networkStatus) => {
    const list: ICoverageServer[] = Object.values(data)
      .sort((a, b) => compareStrings(a.name, b.name));
    return { list, networkStatus };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
